/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Kpi_ConversionInputs */

const cs_dashboard_kpi_conversion = /** @type {(inputs: Dashboard_Kpi_ConversionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konverze`)
};

const en_dashboard_kpi_conversion = /** @type {(inputs: Dashboard_Kpi_ConversionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversion`)
};

/**
* | output |
* | --- |
* | "Conversion" |
*
* @param {Dashboard_Kpi_ConversionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const dashboard_kpi_conversion = /** @type {((inputs?: Dashboard_Kpi_ConversionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Kpi_ConversionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_kpi_conversion(inputs)
	return cs_dashboard_kpi_conversion(inputs)
});